export default "/css/hd.css";